import { useState, useEffect } from 'react';

const useScreenOrientation = (): boolean => {
    
  const [landscape, setLandscape] = useState<boolean>(true);

  useEffect(() => {
    const determineOrientation = () => {
      setLandscape(window.innerWidth > window.innerHeight);
    };

    // Establecer la orientación inicial
    determineOrientation();

    window.addEventListener('resize', determineOrientation);

    // Limpiar el event listener al desmontar el componente
    return () => window.removeEventListener('resize', determineOrientation);
  }, []);

  return landscape;
};

export default useScreenOrientation;